import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=0845202e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0845202e')) {
      api.createRecord('0845202e', component.options)
    } else {
      api.reload('0845202e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=0845202e&", function () {
      api.rerender('0845202e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-484pp4dbPaoN5/JS/comp/childrenage.vue"
export default component.exports